import { apiRequestDev } from './apiRequest';

export const getWardsShapesByCityId = async (config, cityId) => apiRequestDev(config, `/wards/shapes/city/${cityId}`);

export const getWardMessagesInfo = async (config, userId, cityId, category, subcategory, days, startDate, endDate) => {
  let url = `/wards/activity/city/${cityId}?userId=${userId}&category=${encodeURIComponent(category)}&subcategory=${encodeURIComponent(subcategory)}&days=${days}`;

  if (days === 'custom' && startDate && endDate) {
    url += `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  }

  return apiRequestDev(config, url);
};

export const getWardMessagePoints = async (config, userId, cityId, category, subcategory, days, startDate, endDate) => {
  let url = `/wards/activity/points/city/${cityId}?userId=${userId}&category=${encodeURIComponent(category)}&subcategory=${encodeURIComponent(subcategory)}&days=${days}`;

  if (days === 'custom' && startDate && endDate) {
    url += `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  }

  return apiRequestDev(config, url);
};

export const getWardsShapes = async (config, cityId) => apiRequestDev(config, `/wards/shapes/city/${cityId}`);

export const getWardData = async (config, userId, wardId, category, subcategory, days, startDate, endDate) => {
  let url = `/wards/data/${wardId}?userId=${userId}`;

  if (category && subcategory && days) {
    url += `&category=${encodeURIComponent(category)}&subcategory=${encodeURIComponent(subcategory)}&days=${days}`;

    if (days === 'custom' && startDate && endDate) {
      url += `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
    }
  }

  return apiRequestDev(config, url);
};
